import React from "react";
import { Routes, Route } from "react-router-dom";
import { PageProjection, ProjectFiche, PageSimulation } from "../pages/inmersys";
import { ProjectRoot } from "./type_router";



export const ProjectRouter = () => {
    return (
        <Routes>
            <Route path={ProjectRoot.selectproject} element={<ProjectFiche />} />
            <Route path={ProjectRoot.proyeccion} element={<PageProjection />} />
            <Route path={ProjectRoot.simulation} element={<PageSimulation />} />
        </Routes>
    );
};
